module.exports = __webpack_public_path__ + "static/media/cloud-island-bg.cb934217.svg";